// Import Styles
import '../sass/styles.scss';

// Import Plugins
// import 'bootstrap';

import './slider/post-latest';
import './slider/post-related';
import './slider/post-featured';

// Import JS Class
// import { Helpers } from './helpers/helpers'
import { LoadMore } from './ajax/load-more';

(function () {
    
    // const helper = new Helpers(); 
     

    $(document).ready(function() 
    {

        $(document).scroll(function() {
            if ($(this).scrollTop() > 200) {
                $('.js-scroll-top').fadeIn(200); // Show element
            } else {
                $('.js-scroll-top').fadeOut(200); // Hide element
            }
        });               

        $('.js-scroll-top').click(function() {
            $("html, body").animate({
                scrollTop: 0
            }, "slow");
        });


        // helper.wrapTitles();

        // Setup AJAX Load More
        const loadMore = new LoadMore();

        // Navigation

        $('.js-navigation-side__hamburger').on('click', function() {
            $('.js-navigation-side').addClass('active');
        });

        $('.js-navigation-side__close').on('click', function() {
            $('.js-navigation-side').removeClass('active');
        });

        $('.js-collapse__title').on('click', function() {
            $(this).toggleClass('active');
            $(this).next('.js-collapse__body').toggleClass('active');
        });

        // Search Popup

        $('.js-header-bottom--mobile__search').on('click', function() {
            $('.js-search-form').addClass('active');
        });

        $('.js-search-form__close').on('click', function() {
            $('.js-search-form').removeClass('active');
        });

        // Double Tap to Go

        if( window.matchMedia( '(max-width: 991px)' ).matches )
		{
			var previousTarget = null;

			$('.menu-item-has-children > a').on('click', function(e)
			{
                $('.sub-menu').removeClass('js-open');

				if ( this === previousTarget ) 
				{
					// Do nothing...
				}
				else
				{
					e.preventDefault();
					previousTarget = this;
				}

				$(this).next('.sub-menu').toggleClass('js-open');
			});
		}

        // Mobile Scroll
        
        if( window.matchMedia( '(max-width: 991px)' ).matches )
        {
            const urlParams = new URLSearchParams(window.location.search);
            const mobileScroll = urlParams.get('scroll');

            // Navigation Items
            $('.js-navigation-main a').each(function()
            {
                let url = $(this).attr('href').split("?")[0];
                let urlQuery = url + '?scroll=' + mobileScroll;
                $(this).attr('href', urlQuery);
            });

            // Posts
            $('.js-navigation-scroll a').each(function()
            {
                let url = $(this).attr('href').split("?")[0];
                let urlQuery = url + '?scroll=' + mobileScroll;
                $(this).attr('href', urlQuery);
            });
        }

        // Accordion 
        $('.js-accordion-title').on('click', function() {
            var content = $(this).next('.js-accordion-content');
            $(this).toggleClass('active');
            content.toggleClass('active');
        });
    });

    $(window).scroll(function() {

        let topHeaderHeight, middleHeaderHeight, bottomHeader, bottomHeaderHeight, headerOffset;

        if ( $(window).width() >= 768 )
        {
            topHeaderHeight = $('.js-header-top').outerHeight();
            middleHeaderHeight = $('.js-header-middle').outerHeight();
            bottomHeader = $('.js-header-bottom');
            bottomHeaderHeight = $('.js-header-bottom').outerHeight();

            headerOffset = topHeaderHeight + middleHeaderHeight;
        }
        else
        {
            topHeaderHeight = $('.js-header-top--mobile').outerHeight();
            middleHeaderHeight = $('.js-header-middle--mobile').outerHeight();
            bottomHeader = $('.js-header-bottom--mobile');
            bottomHeaderHeight = $('.js-header-bottom--mobile').outerHeight();
            

            headerOffset = topHeaderHeight + middleHeaderHeight;
        }

        let siteContent = $('.js-site-content');

        if ( $(window).scrollTop() >= headerOffset )
        {
            bottomHeader.css('position', 'fixed');
            siteContent.css('margin-top', bottomHeaderHeight);
        }
        else
        {
            bottomHeader.css('position', 'relative');
            siteContent.css('margin-top', 0);
        }

        /**
         * Sticky Sidebar on Articles 
         */
        if ( $(window).width() >= 992 )
        {
            let article = $('.l-post');
            let stickySidebar = $('.js-sticky-sidebar');
            let scrollIndicatorIcon = $('.c-scroll-indicator__icon');
            let stickySidebarHeight = stickySidebar.outerHeight();
            let bannerHeight = $('.js-header-image').outerHeight();
            let articleHeight = article.outerHeight();

            // Offset from the top of the window to the bottom of the banner image
            let offsetToArticle = headerOffset + bannerHeight;
            // Offset from the top of the window to the bottom of the article
            let offsetToBottomArticle = article.offset().top + articleHeight
            // Height of sticky sidebar adjusted for offset from header & overlap positioned article (30px)
            let offsetStickySidebar = bottomHeaderHeight + stickySidebarHeight + 30;

            if ( $(window).scrollTop() >= offsetToArticle && ($(window).scrollTop() < offsetToBottomArticle - offsetStickySidebar) ) // In Article
            {
                stickySidebar.css('position', 'fixed');
                stickySidebar.css('top', bottomHeaderHeight);
                stickySidebar.css('bottom', 'unset');
                scrollIndicatorIcon.text('close');
            }
            else if ( ($(window).scrollTop() >= offsetToBottomArticle - offsetStickySidebar) ) // Bellow Article
            {
                stickySidebar.css('position', 'absolute');
                stickySidebar.css('top', 'unset');
                stickySidebar.css('bottom', 0);
            }
            else // Above Article
            {
                stickySidebar.css('position', 'relative');
                stickySidebar.css('top', 0);
                stickySidebar.css('bottom', 'unset');
            }
        }
    });

    $('.js-navigation-main').scroll(function() {

        let scrollLeft, menuWidth;

        scrollLeft = $(this).scrollLeft();
        menuWidth = $(this)[0].scrollWidth;

        if ( scrollLeft > 0 )
        {
            $(this).addClass('scrolled');
        }
        else
        {
            $(this).removeClass('scrolled');
        }

        if ( scrollLeft >= menuWidth - $(window).width() )
        {
            $('.js-header-bottom--mobile__search').addClass('scrolled');
        }
        else
        {
            $('.js-header-bottom--mobile__search').removeClass('scrolled');
        }   
        
        // Mobile Scroll

        if( window.matchMedia( '(max-width: 991px)' ).matches )
        {
            $('.js-navigation-main a').each(function()
            {
                let url = $(this).attr('href').split("?")[0];
                let urlQuery = url + '?scroll=' + scrollLeft;
                $(this).attr('href', urlQuery);
            });
        }
    });

})();